import React, { useState, useMemo, useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-timezone'
import { changeObjectPropertyAction } from 'redux/actions'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'
import BackAnchor from 'shared/components/BackAnchor';
import { initialMedavieDifferentAddress } from '../../../../redux/reducers/appReducer';
import { validateApartmentErrors, validateCityErrors, validatePostalCodeErrors, validateStreetAddressErrors } from '../../../../shared/helpers/validators'

import MedavieQuestion from './MedavieQuestion'

import AddressAutofill from '../../../../shared/components/Address/AddressAutofill'
import StreetAddress from '../../../../shared/components/Address/StreetAddress';
import Apartment from '../../../../shared/components/Address/Apartment'
import City from '../../../../shared/components/Address/City'
import PostalCode from '../../../../shared/components/Address/PostalCode'
import styles from './CurrentAddress.module.scss'

const CURRENT_ADDRESS = 'currentAddress';

const CurrentAddressView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch();

  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const [streetAddressValid, setStreetAddressValid] = useState('')
  const [apartmentValid, setApartmentValid] = useState('')
  const [cityValid, setCityValid] = useState('')
  const [postalCodeValid, setPostalCodeValid] = useState('')

  const [streetAddressError, setStreetAddressError] = useState('current_address.street_address_error')
  const [apartmentError] = useState('current_address.apartment_error_invalid')
  const [cityError, setCityError] = useState('current_address.city_error')
  const [postalCodeError, setPostalCodeError] = useState('current_address.postal_code_error')

  const [medavieAddressErrors, setMedavieAddressErrors] = useState({ ...initialMedavieDifferentAddress });

  const { city, streetAddress, apartment, postalCode, medavieDifferentAddress } = useSelector((state) => state.app.currentAddress)

  const currentAddressSameMedavie = useSelector((state) => state.app.currentAddress.currentAddressSameMedavie);
  const { jointlyRegistered, nsHealthCard, registeredBusiness, driverLicence, registeredByName } = useSelector((state) => state.app.addressTypeChange)

  // const [tempArrState, setTempArrState] = useState([]);

  // const [tempPostalArrState, setTempPostalArrState] = useState([]);

  const isSummary = useMemo(() => {
    return JSON.parse(new URLSearchParams(history.location.search).get("isSummary") ?? false);
  }, [history]);

  // const continueCancelProps = {
  //   prevText: t('current_address.back'),
  //   prevURL: `/${i18n.language}${t('routes.listed_permits')}`,
  //   nextText: t('current_address.next'),
  // }

  // useEffect(() => {
  //   try {
  //     if (!nsHealthCard && !driverLicence && !vehiclePermit && !registeredByName) {
  //       history.push(`/${i18n.language}${t('routes.address_type_change')}`)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }, [])

  const isRMV = useMemo(() => {
    return driverLicence || registeredByName || jointlyRegistered || registeredBusiness
  }, [driverLicence, registeredByName, jointlyRegistered, registeredBusiness]);

  const nextRoute = useMemo(() => {
    if (driverLicence || registeredByName || nsHealthCard) {
      return t('routes.personal_info');
    }
    if (jointlyRegistered) {
      return t('routes.jointly_owned_vehicle_info');
    }
    if (registeredBusiness) {
      return t('routes.business_vehicle_info');
    }
    return t('routes.not_found');
  }, [jointlyRegistered, registeredBusiness, driverLicence, registeredByName, nsHealthCard, t]);

  const onNext = () => {
    try {
      if (validateFields()) {
        if (isSummary) {
          history.push(`/${i18n.language}${t('routes.review_summary')}`)
        } else {
          history.push(`/${i18n.language}${nextRoute}`)
        }
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {
      validateStreetAddress(streetAddress)
      validateApartment(apartment)
      validateCity(city)
      validatePostalCode(postalCode)
      if (streetAddress === '') {
        setStreetAddressValid(false)
      }
      if (city === '') {
        setCityValid(false)
      }
      if (postalCode === '') {
        setPostalCodeValid(false)
      }
      let medavieAddressValid = true;
      if (isRMV && !currentAddressSameMedavie) {
        medavieAddressErrors.streetAddress = validateStreetAddressErrors(medavieDifferentAddress.streetAddress)
        medavieAddressErrors.apartment = validateApartmentErrors(medavieDifferentAddress.apartment);
        medavieAddressErrors.city = validateCityErrors(medavieDifferentAddress.city);
        medavieAddressErrors.postalCode = validatePostalCodeErrors(medavieDifferentAddress.postalCode);

        if (medavieAddressErrors.streetAddress === '') {
          medavieAddressErrors.streetAddress = 'current_address.street_address_error';
        }
        // if (medavieAddressErrors.apartment === '') {
        //   medavieAddressErrors.apartment = 'current_address.apartment_error_invalid';
        // }
        if (medavieAddressErrors.postalCode === '') {
          medavieAddressErrors.postalCode = 'current_address.postal_code_error';
        }
        if (medavieAddressErrors.city === '') {
          medavieAddressErrors.city = 'current_address.city_error_invalid';
        }

        setMedavieAddressErrors({ ...medavieAddressErrors });

        medavieAddressValid = (
          !medavieAddressErrors.streetAddress &&
          (medavieAddressErrors.apartment === '' || !medavieAddressErrors.apartment) &&
          !medavieAddressErrors.cityValid &&
          !medavieAddressErrors.postalCode &&
          medavieDifferentAddress.streetAddress !== '' &&
          // apartment !== '' &&
          medavieDifferentAddress.city !== '' &&
          medavieDifferentAddress.postalCode !== ''
        )
      }
      return (
        streetAddressValid === true &&
        (apartmentValid === '' || apartmentValid === true) &&
        cityValid === true &&
        postalCodeValid === true &&
        streetAddress !== '' &&
        // apartment !== '' &&
        city !== '' &&
        postalCode !== '' &&
        medavieAddressValid
      )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateStreetAddress = (name) => {
    try {
      const regex = RegExp(/^.*$/);
      if (name.length > 0) {
        if (regex.test(name)) {
          setStreetAddressValid(true)
        } else {
          setStreetAddressValid(false)
          setStreetAddressError('current_address.street_address_error')
        }
      } else {
        setStreetAddressValid(false)
        setStreetAddressError('current_address.street_address_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  // console.log(tempArrState)

  const validateApartment = (name) => {
    setApartmentValid(true)
    return;
    // try {
    //   const regex = RegExp(/^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
    //   if (name.length > 0) {
    //     if (regex.test(name)) {
    //       setApartmentValid(true)
    //     } else {
    //       setApartmentValid(false)
    //       setApartmentError('current_address.apartment_error_invalid')
    //     }
    //   } else {
    //     setApartmentValid('')
    //     // setApartmentError('current_address.apartment_error')
    //   }
    // } catch (e) {
    //   console.log(e)
    //   setIsError(true)
    // }
  }


  const validateCity = (cityName) => {
    try {
      const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
      if (cityName.length > 0) {
        if (regex.test(cityName)) {
          setCityValid(true)
        } else {
          setCityValid(false)
          setCityError('current_address.city_error')
        }
      } else {
        setCityValid(false)
        setCityError('current_address.city_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }


  const validatePostalCode = (number) => {
    try {
      const regex = RegExp(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i)
      if (regex.test(number)) {
        setPostalCodeValid(true)
      } else {
        setPostalCodeValid(false)
        setPostalCodeError('current_address.ns_postal_code_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const handleChangeObjectPropertyAction = useCallback((fieldName, value) => {
    dispatch(changeObjectPropertyAction('currentAddress', fieldName, value))
  }, [dispatch]);

  const addressMatch = useMemo(() => {
    const isMedavie = nsHealthCard;

    if (isMedavie && isRMV) {
      return `${t('current_address.this_address_must_match_rmv_and_blue_cross')}`;
    } else if (isRMV) {
      return `${t('current_address.this_address_must_match_rmv')}`;
    } else {
      return `${t('current_address.this_address_must_match_medavie')}`;
    }
  }, [isRMV, nsHealthCard, t]);

  const currentAddressInfo = useMemo(() => {
    const isMedavie = nsHealthCard;

    if (isMedavie && isRMV) {
      return `${t('current_address.current_home_address_rmv_and_blue_cross')}`;
    } else if (isRMV) {
      return `${t('current_address.current_home_addeess_rmv')}`;
    } else {
      return `${t('current_address.current_home_address_medavie')}`;
    }
  }, [isRMV, nsHealthCard, t]);
  return (
    <div className="container">
      <main>
        <article>
          <BackAnchor />
          <div className="row">
            <div className="col-xs-12">
              <h1>{t('current_address.what_is_your')}</h1>
              <div className={styles['addrress-must-match-container']}>
                <i aria-label={t('shared.warning')} className={"fa fa-exclamation-triangle error-indicator fa-2x has-warning errorAlert " + styles['warning-alert']} aria-hidden="true"></i>
                <p>
                  <strong>{addressMatch}.</strong>
                </p>
              </div>
              <h2>{currentAddressInfo}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">

              <AddressAutofill
                validateStreetAddress={validateStreetAddress}
                streetAddressError={streetAddressError}
                streetAddressValid={streetAddressValid}
                setIsError={setIsError}
                reduxAppProperty={CURRENT_ADDRESS}
                changeObjectPropertyAction={handleChangeObjectPropertyAction}
                validateCity={validateCity}
                validatePostalCode={validatePostalCode}
                cityError={cityError}
                cityValid={cityValid}
                postalCodeError={postalCodeError}
                postalCodeValid={postalCodeValid}
                validateApartment={validateApartment}
                apartmentError={apartmentError}
                apartmentValid={apartmentValid}
              />

              {/* <Apartment
                validateApartment={validateApartment}
                apartmentError={apartmentError}
                apartmentValid={apartmentValid}
                setIsError={setIsError}
                reduxAppProperty={CURRENT_ADDRESS}
                changeObjectPropertyAction={handleChangeObjectPropertyAction}
              /> */}
              {/* <StreetAddress
                validateStreetAddress={validateStreetAddress}
                streetAddressError={streetAddressError}
                streetAddressValid={streetAddressValid}
                setIsError={setIsError}
                reduxAppProperty={CURRENT_ADDRESS}
                changeObjectPropertyAction={handleChangeObjectPropertyAction}
                tempArrState={tempArrState}
                setTempArrState={setTempArrState}
                tempPostalArrState={tempPostalArrState}
                setTempPostalArrState={setTempPostalArrState}
              />
              <Apartment
                validateApartment={validateApartment}
                apartmentError={apartmentError}
                apartmentValid={apartmentValid}
                setIsError={setIsError}
                reduxAppProperty={CURRENT_ADDRESS}
                changeObjectPropertyAction={handleChangeObjectPropertyAction}
              />
              <City
                validateCity={validateCity}
                validatePostalCode={validatePostalCode}
                cityError={cityError}
                cityValid={cityValid}
                setIsError={setIsError}
                reduxAppProperty={CURRENT_ADDRESS}
                changeObjectPropertyAction={handleChangeObjectPropertyAction}
                tempArrState={tempArrState}
              />
              <PostalCode
                validatePostalCode={validatePostalCode}
                postalCodeError={postalCodeError}
                postalCodeValid={postalCodeValid}
                setIsError={setIsError}
                reduxAppProperty={CURRENT_ADDRESS}
                changeObjectPropertyAction={handleChangeObjectPropertyAction}
                tempPostalArrState={tempPostalArrState}
              /> */}
            </div>
          </div>
          {isRMV && nsHealthCard && (
            <MedavieQuestion
              medavieAddressErrors={medavieAddressErrors}
              setMedavieAddressErrors={setMedavieAddressErrors}
            />
          )}
          <ContinueCancelButtons continueClick={onNext} errorText={''} />
        </article>
      </main>
    </div>
  )
}

export default withTranslation('common')(CurrentAddressView)
